/* eslint-disable */
import TeamsService from '@/services/api/teams.services'
// import store from "@/store";
// import store from "@/store";


const state = {
    teamsList: [],
    questions: [],
    user_answers: [],
    myTeamList: [],
    myResults: {},
    mateResults: {},
    allTeams: [],
    mateWhoVoted: [],
    isReview: false,
    graph: false,
    isReviewStatusGot: false,
    cycles: [],

}

const mutations = {

  CLEAR_GRAPH(state) {
    state.graph = false
  },

    SET_TEAMS(state, payload) {
        state.teamsList = payload
    },

  SET_IS_REVIEW(state, payload) {
    state.isReview = payload
  },

    SET_CYCLES(state, payload) {
        state.cycles = payload
    },

  SET_GRAPH(state, payload) {
    state.graph = payload
  },

  SET_MY_TEAMS(state, payload) {
    state.myTeamList = payload
  },

  SET_ALL_TEAMS(state, payload) {
    state.allTeams = payload
  },

  SET_QUESTIONS(state, payload) {
    state.questions = payload
  },

  SET_USER_ANSWERS(state, payload) {
    state.user_answers = payload
  },

  SET_MY_RESULTS(state, payload) {
    state.myResults = payload
  },

  SET_MATE_RESULTS(state, payload) {
    state.mateResults = payload
  },

  SET_MATE_WHO_VOTED(state, payload) {
    state.mateWhoVoted = payload
  },

  SET_IS_REVIEW_STATUS(state) {
    state.isReviewStatusGot = true
  },

}

const actions = {

  setReviewStatus({commit}, payload) {
    return new Promise((resolve, reject) => {
      TeamsService.setReviewStatus(
        payload
      )
        .then((response) => {
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

  getReviewStatus({ commit }) {
    return new Promise((resolve, reject) => {
      TeamsService.get('reviewStatus')
        .then((response) => {
          commit('SET_IS_REVIEW', response.data.data)
          commit('SET_IS_REVIEW_STATUS')
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

  getAllQuestions({ commit }) {
    return new Promise((resolve, reject) => {
      TeamsService.get('getQuestions')
        .then((response) => {
          commit('SET_QUESTIONS', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

  selfAssessmentPost({ commit }, payload) {
    return new Promise((resolve, reject) => {
      TeamsService.selfAssessment(
        payload
      )
        .then((response) => {

          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

  getUserAnswers({commit}, payload) {
    return new Promise((resolve, reject) => {
      TeamsService.getUserAnswers(
        payload.user_id,
        payload.author_id
      )
        .then((response) => {
          commit('SET_USER_ANSWERS', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

    getUserAnswersCycle({commit}, payload) {
        return new Promise((resolve, reject) => {
            TeamsService.getUserAnswersCycle(
                payload.user_id,
                payload.author_id,
                payload.cycle_id
            )
                .then((response) => {
                    commit('SET_USER_ANSWERS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    getCycles({commit}) {

        return new Promise((resolve, reject) => {
            TeamsService.getCycles()
                .then((response) => {
                    commit('SET_CYCLES', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    getUserAnswersByName({commit}, payload) {
        return new Promise((resolve, reject) => {
            TeamsService.getUserAnswersByName(
                payload.user_name,
                payload.author_name,
            )
                .then((response) => {
                    commit('SET_USER_ANSWERS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

  getUserAnswersByNameCycle({commit}, payload) {
    return new Promise((resolve, reject) => {
      TeamsService.getUserAnswersByNameCycle(
        payload.user_name,
        payload.author_name,
        payload.cycle_id
      )
        .then((response) => {
          commit('SET_USER_ANSWERS', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

  getGraph({commit}, payload) {
    return new Promise((resolve, reject) => {
      TeamsService.getGraph(
        payload.user_name,
      )
        .then((response) => {
          commit('SET_GRAPH', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

    getGraphCycle({commit}, payload) {
        return new Promise((resolve, reject) => {
            TeamsService.getGraphCycle(
                payload.user_name,
                payload.cycle_id
            )
                .then((response) => {
                    commit('SET_GRAPH', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

  resetMyAnswers({commit}, payload) {

    return new Promise((resolve, reject) => {
      TeamsService.resetAnswers(
        payload.user_id,
        payload.author_id
      )
        .then((response) => {
          commit('SET_USER_ANSWERS', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },




    getTeamsList({ commit }) {
        return new Promise((resolve, reject) => {
            TeamsService.get('getTeams')
                .then((response) => {
                    commit('SET_TEAMS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

  getMyTeams({commit}, payload) {
    return new Promise((resolve, reject) => {
      TeamsService.getMyTeams(
        payload.user_id
      )
        .then((response) => {
          commit('SET_MY_TEAMS', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

  getAllTeams({ commit }) {
    return new Promise((resolve, reject) => {
      TeamsService.get('getTeams')
        .then((response) => {
          commit('SET_ALL_TEAMS', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },


  changeTeam({commit}, payload) {
    return new Promise((resolve, reject) => {
      TeamsService.changeTeam(
        payload.userId,
        payload.form
      )
        .then((response) => {

          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

  createTeam({commit}, payload) {
    return new Promise((resolve, reject) => {
      TeamsService.createTeam(
        payload.form
      )
        .then((response) => {

          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

  deleteTeam({commit}, payload) {
    return new Promise((resolve, reject) => {
      TeamsService.deleteTeam(
        payload
      )
        .then((response) => {

          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },


  getMyResults({commit}, payload) {
    return new Promise((resolve, reject) => {
      TeamsService.getMyResults(
        payload
      )
        .then((response) => {
          commit('SET_MY_RESULTS', response.data.data)

          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

    getMyResultsCycle({commit}, payload) {
        return new Promise((resolve, reject) => {
            TeamsService.getMyResultsCycle(
                payload.user_id,
                payload.cycle_id
            )
                .then((response) => {
                    commit('SET_MY_RESULTS', response.data.data)

                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

  getMateResults({commit}, payload) {
    return new Promise((resolve, reject) => {
      TeamsService.getMateResults(
        payload
      )
        .then((response) => {
          commit('SET_MATE_RESULTS', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

    getMateResultsCycle({commit}, payload) {
        return new Promise((resolve, reject) => {
            TeamsService.getMateResultsCycle(
                payload.author_id,
                payload.cycle_id
            )
                .then((response) => {
                    commit('SET_MATE_RESULTS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

  getMateWhoVoted({commit}, payload) {
    return new Promise((resolve, reject) => {
      TeamsService.getMateWhoVoted(
        payload
      )
        .then((response) => {
          commit('SET_MATE_WHO_VOTED', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

    getMateWhoVotedCycle({commit}, payload) {
        return new Promise((resolve, reject) => {
            TeamsService.getMateWhoVotedCycle(
                payload.name,
                payload.id
            )
                .then((response) => {
                    commit('SET_MATE_WHO_VOTED', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

}

const getters = {
    getTeamsList: (state) => state.teamsList,
    getQuestionsList: (state) => state.questions,
    getUserAnswersList: (state) => state.user_answers,
    getMyTeamList: (state) => state.myTeamList,
    getAllTeamList: (state) => state.allTeams,
    getMyResults: (state) => state.myResults,
    getMateResults: (state) => state.mateResults,
    isReviewRunning: (state) => state.isReview,
    getMateWhoVoted: (state) => state.mateWhoVoted,
    getGraphData: (state) => state.graph,
    isReviewStatusGot: (state) => state.isReviewStatusGot,
    getCycles: (state) => state.cycles



}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
